import * as es6Promise from 'es6-promise-polyfill';
// the polyfill will use native promises if available
export default es6Promise.Promise;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@salecycle/client-script-core/src/libs/promises.js
// module id = 2
// module chunks = 0